import type { FaireProductEntity } from "../../entity_types/product";

export const p_86si40jl: FaireProductEntity = {
  token: "p_86si40jl",
  type: "product",
  name: "Thank You! Card",
  brandToken: "b_71j1sxhj",
  brandName: "IMPAPER",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/9f1e17317e68143ed8f51ff11396d9a846023560e74a62889503fc9448598a02/1518159996.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/111c801989c2eb28c7483ed3b5984ca02e8d6e36d051f47599d135af8f274133/1541485464.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/1594f6b403c44296f4f384f4daf7260d3669e54fe930177535b568158276b347/1518148138.jpg",
    "https://cdn.faire.com/fastly/9d04f5d767f275d03111c300d944e2e2aa462cf2a3f78487da3509380213fd1c.png",
    "https://cdn.faire.com/fastly/d4aecaf5d46a6056c7f096f2d4f8fdc5af984241ad3e18c221a4d5fc087cc8dd.png",
    "https://cdn.faire.com/fastly/7c543ac6ea91a756374fe8f469e6943ace79575ac64282d9d68566ac49d8097e.png",
  ],
  priceDollars: 2.5,
  description:
    "Give a card that gives: Every card purchased donates to a cause (meals for hunger relief, vaccines for diseases, tree planting & more!).\n\n• Size: A2 (4.25 x 5.5 inches folded)\n• Envelope: Kraft square flap envelope with no-lick peel & stick strip\n• Inside: Blank uncoated interior for a superior writing experience\n• Packaging: Protective clear cellophane sleeve with sticker indicator of donation type\n• Shipping: United States (USPS/FedEx) and Canada (UPS/Canada Post). No cross-border charges, duty-free shipping",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:04.712Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
